var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resources-Icon",
    transform: "translate(-401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(401)",
    fill: "#211f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M11,7.083h1.333M11,9.75h1.333M5.667,12.417h6.667M5.667,15.083h6.667m2.667-8h3a1,1,0,0,1,1,1v8.333a2,2,0,0,1-2,2M15,7.083v9.333a2,2,0,0,0,2,2M15,7.083V4.75a1,1,0,0,0-1-1H4a1,1,0,0,0-1,1V16.417a2,2,0,0,0,2,2H17M5.667,7.083H8.333V9.75H5.667Z",
    transform: "translate(410 8.917)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesIcon);
export default __webpack_public_path__ + "static/media/ResourcesIcon.9a239be83cd9fe846eae36dba664edd1.svg";
export { ForwardRef as ReactComponent };